<template>
  <div class="userRow py-2 px-4">

    <!-- View subscription / customer portal -->
    <div class="has-text-left mb-4" v-if="subscription">
      <!-- show status -->
      <p class="title is-5 mt-2 mb-1">
        Your subscription is {{ subscription.status }} 
        <span v-if="subscription.cancel_at_period_end"> and set to cancel</span>
      </p>
      <!-- show trial end date -->
      <p v-if="subscription.status === 'trialing'">
        Your {{ subscription.price.trial_period_days }} day trial ends <strong>{{ $root.getDate(subscription.trial_end.seconds, true) }}</strong>
      </p>
      <!-- next bill date, if not cancelled -->
      <p v-if="!subscription.cancel_at_period_end">
        Your account will be charged <strong>{{ $root.getDate(subscription.current_period_end.seconds, true) }}</strong>
      </p>
      <!-- cancel date -->
      <p v-else class="subtitle is-6 mb-2">
        This will not renew, and you will lose access to Aceso on 
        <strong>{{ $root.getDate(subscription.cancel_at.seconds, true) }}</strong>
      </p>
      <!-- view or edit subscription -->
      <b-button @click="viewSubscription()" :loading="isLoading" class="is-info is-light mt-2" rounded>
        <strong>See/Edit Payment Details</strong>
      </b-button>
    </div>

    <!-- List Products, only for starting a subscription. If there is an active or trialing subscription, or their plan is set to cancel, we show this. -->
    <div v-if="showProducts">
      <p class="title is-4 has-text-left mb-2" >Plans</p>
      <div v-for="product in products" :key="product.id" class="has-text-left">
        <p class="title is-6">{{ product.name }}</p>
        <p class="subtitle is-6 mb-1">{{ product.description }}</p>
        <div v-for="price in product.prices" :key="price.id" class="columns">
          <div class="column">
            <p>{{ prettyPrice(price) }}</p>
          </div>
          <div class="column">
            <b-button @click="checkout({ price: price.id })" :loading="isLoading" class="is-success is-light" rounded>
              <strong>Start Plan</strong>
            </b-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import { mapState, mapActions, mapGetters } from 'vuex';


export default {
  name: "stripeComponents",
  mounted() {
    this.fetchProducts();
  },
  data() {
    return {

    }
  },
  computed: {
    showProducts() { // only show products/plans if there is no active subscription
      if (!this.subscription || (this.subscription.status !== 'active' && this.subscription.status !== 'trialing')) {
        // removed || this.subscription.cancel_at_period_end since cancelling at period ends means they are still active, and won't need to select a plan to renew
        return true;
      } else {
        return false;
      }
    },
    ...mapState({
      isLoading: state => state.stripe.isLoading,
      products: state => state.stripe.products,
      // user: state => state.auth.user,
    }),
    ...mapGetters({
      subscription: "stripe/getSubscription"
    })
  },
  methods: {
    prettyPrice(price) {
      const dollars = price.unit_amount / 100;
      return `$${dollars} / ${price.interval}`;
    },
    ...mapActions({
      viewSubscription: 'stripe/viewSubscription',
      fetchProducts: 'stripe/fetchProducts',
      checkout: 'stripe/checkout',
    })
  }
};
</script>


<style lang="scss" scoped>
fieldset {
  background-color: #f6f8fa;
}
#error-message {
  color: red;
  height: 2em;
}
.userRow {
  background-color: white;
  border-radius: 8px;
  margin-bottom: 0.5em;
}
</style>